import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Offcanvas, Button } from 'react-bootstrap';
import { Link, NavLink, redirect, useLocation } from 'react-router-dom';
import Cookies from "js-cookie";
import logo from "../../assets/images/logo.png"

import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { userProfile } from '../../store/user/userThunk';
import { Menu } from 'lucide-react';
const LayoutsNavbar = ({ setSidebarOpen, sidebarOpen }) => {
  let { profile } = useSelector((state) => state.userservice);
  const token = Cookies.get("token");
  const location = useLocation()
  let twofatoken = Cookies.get("twofatoken");
  const [active, setActive] = useState("home");
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const navigator = useNavigate()
  const handleOffcanvasToggle = () => setShowOffcanvas(!showOffcanvas);
  let dispatch = useDispatch();
  const handleClick = () => {
    navigator("/dashboards")
  }
  useEffect(() => {
    if (profile === null) {

      dispatch(userProfile())
    }
  }, [])
  const isDocumentationPage = location.pathname.startsWith('/pages/documention');
  return (
    <header className="navbar-LayoutsNavbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="d-flex justify-content-between py-3 align-items-center">
          <div className='d-flex'>
            {isDocumentationPage && (
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="2xl:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#50B5FF]"
              >
                <Menu size={24} />
              </button>
            )}
            <div className="logo">
              <Link
                to="/"
                className="d-flex align-items-center gap-[5px] iq-header-logo ms-[20px] sidebar-default-logo
                        my-[18px]"
              >

                <img src={logo} className="max-w-[150px] max-h-[50px] sidebar-default-logo" />

                {/* <h3 className="logo-title" data-setting="app_name">
                  <span className="block text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#50B5FF] via-blue-500 to-purple-500 font-logo">
                    Chat Inject
                  </span>
                </h3> */}
              </Link>
            </div>
          </div>
          <div>
            {/* Hamburger button for mobile view */}
            <Button
              variant="outline-dark"
              className="d-md-none"
              onClick={handleOffcanvasToggle}
            >
              <i className="fas fa-bars"></i>
            </Button>

            {/* Desktop navigation */}
            <Nav className="d-none d-md-flex ml-auto">
              <ul className="iq-nav-menu main-menu flex-md-row list-unstyled d-flex">
                <li className="nav-item">
                  <NavLink
                    className={`nav-link menu-arrow justify-content-start`}
                    to="/"
                  >
                    <span className="nav-text">Home</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className={`nav-link menu-arrow justify-content-start`}
                    to="/pages/about"

                  >
                    <span className="nav-text">About</span>
                  </NavLink>
                  {/* <ul className='sub-menu'>
                  <li className="nav-item">
                    <NavLink
                      className={`nav-link menu-arrow justify-content-start`}
                      to="/pages/contact-us"
                    >
                      <span className="nav-text">Content</span>
                    </NavLink>
                    <NavLink
                      className={`nav-link menu-arrow justify-content-start`}
                      to="/pages/contact-us"
                    >
                      <span className="nav-text">Content</span>
                    </NavLink>
                    <NavLink
                      className={`nav-link menu-arrow justify-content-start`}
                      to="/pages/contact-us"
                    >
                      <span className="nav-text">Content</span>
                    </NavLink>
                    <NavLink
                      className={`nav-link menu-arrow justify-content-start`}
                      to="/pages/contact-us"
                    >
                      <span className="nav-text">Content</span>
                    </NavLink>
                  </li>
                </ul> */}

                </li>
                <li className="nav-item">
                  <NavLink
                    className={`nav-link menu-arrow justify-content-start`}
                    to="/pages/contact-us"
                  >
                    <span className="nav-text">Contact</span>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    className={`nav-link menu-arrow justify-content-start`}
                    to="/pages/pricing"
                  >
                    <span className="nav-text">Pricing</span>
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                <NavLink
                  className={`nav-link menu-arrow justify-content-start`}
                  to="/pages/privacy-policy"
                >
                  <span className="nav-text">Privacy-policy</span>
                </NavLink>
              </li> */}
                <li className="nav-item">
                  <NavLink
                    className={`nav-link menu-arrow justify-content-start`}
                    to="/pages/documention/Introduction"
                  >
                    <span className="nav-text">Documention</span>
                  </NavLink>
                </li>
                {/* <Nav.Link href="#docs">Docs</Nav.Link> */}

                {(profile?.is2FAEnabled ? twofatoken : token) ? (
                  <Button variant="outline-dark" style={{ marginLeft: '10px' }} onClick={handleClick}>
                    Dashboard
                  </Button>
                ) : (
                  <li className="nav-item">
                    <NavLink to="/auth/sign-in" className="nav-link menu-arrow">
                      Log In
                    </NavLink>
                  </li>
                )}

              </ul>

            </Nav>
          </div>
        </div>

        {/* Offcanvas menu for mobile view */}
        <Offcanvas
          show={showOffcanvas}
          onHide={handleOffcanvasToggle}
          placement="end"
          className="offcanvas-custom"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="ml-auto">
              <ul className="iq-nav-menu list-unstyled">
                <li className="nav-item">
                  <NavLink
                    className="nav-link menu-arrow py-3"
                    to="/"
                    onClick={() => {
                      handleOffcanvasToggle();
                    }}
                  >
                    <span className="nav-text">Home</span>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    className="nav-link menu-arrow  py-3"
                    to="/pages/about"
                    onClick={() => {
                      handleOffcanvasToggle();
                    }}
                  >
                    <span className="nav-text">About</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link menu-arrow  py-3"
                    to="/pages/contact-us"
                    onClick={() => {

                      handleOffcanvasToggle();
                    }}
                  >
                    <span className="nav-text">Contact</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link menu-arrow  py-3"
                    to="/pages/pricing"
                    onClick={() => {
                      handleOffcanvasToggle();
                    }}
                  >
                    <span className="nav-text">Pricing</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className={`nav-link menu-arrow  py-3 justify-content-start`}
                    to="/documention/Introduction"

                  >
                    <span className="nav-text">Documention</span>
                  </NavLink>
                </li>
                {/* <Nav.Link href="#docs">Docs</Nav.Link> */}
                <li className="nav-item">
                  <NavLink to="/auth/sign-in" className="nav-link menu-arrow  py-3">
                    Log In
                  </NavLink>
                </li>
                {
                  token ?
                    <Button variant="outline-dark " className='my-3' style={{ marginLeft: '10px' }}>
                      Dashboard
                    </Button> : null
                }
              </ul>

            </Nav>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </header>
  );
};

export default LayoutsNavbar;
